import resetEmailSaga from 'src/app/redux/sagas/reset/resetEmailSaga';
import resetNewPasswordSaga from 'src/app/redux/sagas/reset/resetNewPasswordSaga';
import resetNewPasswordSendSaga from 'src/app/redux/sagas/reset/resetNewPasswordSendSaga';
import resetEmailSendSaga from 'src/app/redux/sagas/reset/resetEmailSendSaga';


export default [
  ...resetEmailSaga,
  ...resetEmailSendSaga,
  ...resetNewPasswordSaga,
  ...resetNewPasswordSendSaga
];
